export const quickReplyFilledActiveStyles = {
  color: '#ffffff',
  background: '#64CEF8',
  border: '1px solid #64CEF8',
  borderColor: '#64CEF8'
}

export const quickReplyActiveStyles = {
  background: '#E8F8FD',
  color: '#1EB4EE',
  border: '1px solid #1EB4EE',
  borderColor: '#1EB4EE'
}
